export const LINE_POSITIONS = {
  START_X: 0,
  END_X: 100,
} as const;

const APP_WORDS_PER_MINUTE = 190;
const USER_WORDS_PER_MINUTE = 110;
const MS_PER_MINUTE = 60 * 1000;

export const SPEECH_RATES = {
  APP: {
    WORDS_PER_MINUTE: APP_WORDS_PER_MINUTE,
    MS_PER_WORD: MS_PER_MINUTE / APP_WORDS_PER_MINUTE,
  },
  USER: {
    WORDS_PER_MINUTE: USER_WORDS_PER_MINUTE,
    MS_PER_WORD: MS_PER_MINUTE / USER_WORDS_PER_MINUTE,
  },
} as const;
